import React, { memo, useEffect, useRef, useState } from 'react';
import MultiSelectDropDownNew from '../../../Common/MultiSelectDropDown/MultiSelectDropDownNew';
import { AppConstant } from '../../../../Assests/AppConstant';
import { ReactComponent as DownloadIconLight } from '../../../../Assests/Svg/download-icon-light.svg';
import { ReactComponent as DownloadIconDark } from '../../../../Assests/Svg/download-icon-dark.svg';
import './DownloadSectionSS.css';
import SSPopup from '../../../Common/Popup/SSPopup/SSPopup';
import { CustomDynamicFormSS } from '../../../Common/CustomForm/CustomDynamicFormSS';
import { showAlert, formMultiSelectDataForPayload } from '../../../../Assests/Utility';
import { toast } from 'react-toastify';
import Popup from '../../../Common/Popup/Popup';
import { CustomDynamicForm } from '../../../Common/CustomForm/CustomDynamicForm';
import moment from 'moment';
import _ from 'lodash-es';
import WarehouseFiltersForReports from '../Reports/ReportsSection/SSAppointmentsReport/AllAppointmentsList/Components/WarehouseFiltersForReports';

/**
 * Validates a YYYY-MM-DD string coming from a native <input type="date">.
 *
 * @param {string}  dateStr   - e.target.value  ('' when invalid/incomplete)
 * @param {boolean} badInput  - e.target.validity.badInput
 *             true when the user typed something the browser
 *  cannot parse (e.g. Feb 31, incomplete entry)
 * @param {string}  fieldLabel - human-readable label for error messages
 * @returns {string} error message, or '' when valid
 */
const validateDateInput = (dateStr, badInput, fieldLabel) => {
    // User typed something but the browser could not form a valid date
    // (covers invalid days like Feb 31, or a partially-typed entry)
    if (badInput && !dateStr) {
        return `${fieldLabel}: please enter a valid date (MM/DD/YYYY).`;
    }

    if (!dateStr) return '';

    // Reject years that are not exactly 4 digits (covers 5- and 6-digit years)
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        if (isNaN(year) || parts[0].length !== 4 || year < 1000 || year > 9999) {
            return `${fieldLabel}: year must be a valid 4-digit year (e.g. 2025).`;
        }

        // Calendar-correctness check: rejects e.g. 04/31
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        const dateObj = new Date(`${dateStr}T00:00:00`);
        if (
            isNaN(dateObj.getTime()) ||
            dateObj.getMonth() + 1 !== month ||
            dateObj.getDate() !== day
        ) {
            return `${fieldLabel}: ${parts[1]}/${parts[2]}/${parts[0]} does not exist.`;
        }
    }

    return '';
};


const DownloadSectionBECustomFeilds = (props) => {
    const {
        downloadData,
        themeSelected = "light-mode",
        isDisabled,
        isSchedulePro = false,
        isLoading,
        columnList,
        downloadReport,
        showEmail = false,
        showDateRange = false,
        monthLimit = 6,
        showApptStatus = false,
        filterListArr,
        allowPermission = false,
        showWarehouseFilter = false,
        currentWarehouseFilterSelected,
        setCurrentWarehouseFilterSelected,
        userType = '',
        weeks,
        showUserTypeFilter = false,
        userTypeFilterListArr,
        userTypeFilterTitle = 'Cancelled By',
        defaultStartDate = null,
        defaultEndDate = null,
        defaultApptStatus = null,
        defaultUserTypeFilter = null,
        onOpenPopup = null,
        filterSelected,
        noShow,
        showPoFilter = false,
        filterOptions = [],
        dateRangeDisclaimerText = AppConstant.appointmentReportSummary.dateFilterDisclaimer,
    } = props;

    // Today in YYYY-MM-DD — used as the `max` for Start Date (mirrors main component
    // where start date is capped at today unless an end date is already chosen).
    const todayStr = moment().format('YYYY-MM-DD');

    /**
     * Returns the maximum selectable End Date as a YYYY-MM-DD string.
     *
     * We subtract 1 day from startDate + monthLimit so that the `max` attribute
     * is the last *inclusive* day of the allowed range.
     *
     * Example with monthLimit=3, startDate=2026-03-01:
     *   2026-03-01 + 3 months = 2026-06-01  → minus 1 day = 2026-05-31  ✓
   *
     * This fixes two bugs:
     *Issue 1 – May 31 was incorrectly rejected by the submit validator.
     *   Issue 2 – June 1 was incorrectly selectable in the date picker.
     */
    const getEndDateMaxStr = () => {
        if (dateInputs.startDate) {
            // Inclusive last day: startDate + monthLimit months - 1 day
            const startPlusLimit = moment(dateInputs.startDate)
                .add(monthLimit, 'months')
                .subtract(1, 'day');
            const endOfYear = moment(`${moment().year()}-12-31`);
            return moment.min(startPlusLimit, endOfYear).format('YYYY-MM-DD');
        }
        return `${moment().year()}-12-31`;
    };

    /**
     * Returns the maximum selectable Start Date as a YYYY-MM-DD string.
  * When an end date is already chosen, cap start date at that end date;
     * otherwise cap at today — identical to how the main component behaves.
     */
    const getStartDateMaxStr = () => {
        return dateInputs.endDate ? dateInputs.endDate : todayStr;
    };

    // -------------------------------------------------------------------------
    // Date field state (managed here, outside CustomDynamicFormSS)
    // -------------------------------------------------------------------------
    const initialDateState = { startDate: '', endDate: '' };
    const initialDateErrors = { startDate: '', endDate: '', dateRange: '' };
    const initialDateDirty = { startDate: false, endDate: false };

    const [dateInputs, setDateInputs] = useState(initialDateState);
    const [dateErrors, setDateErrors] = useState(initialDateErrors);
    const [dateDirty, setDateDirty] = useState(initialDateDirty);
    const [dateResetKey, setDateResetKey] = useState(0);

    // particularFieldValue is used to push date values into CustomDynamicFormSS

    const [particularFieldValue, setParticularFieldValue] = useState({});

    // Internal state for po filter and noShow — initialized from props so popup
    // reflects the current page selection when opened, but can be changed independently.
    const [internalFilterSelected, setInternalFilterSelected] = useState(filterSelected || []);
    const [internalNoShow, setInternalNoShow] = useState(noShow || false);

    const getApptStatusList = () => {
        const allData = [
            { name: 'All', id: 1 },
            { name: 'Completed', id: 2 },
            { name: 'Scheduled', id: 3 },
            { name: 'Rescheduled', id: 4 },
            { name: 'Cancelled', id: 5 },
        ];
        const filterDataArr = filterListArr && filterListArr.length ? [...filterListArr] : [...allData];
        const apptList = filterDataArr && filterDataArr.length && filterDataArr.map((ele) => {
            if (ele) {
                return (
                    <option key={ele.name} value={ele.name}>
                        {ele.name}
                    </option>
                );
            }
            return null;
        });
        return _.compact(apptList);
    };

    const getUserTypeFilterList = () => {
        const defaultData = [
            { name: 'All User', id: 1 },
            { name: 'Carrier', id: 2 },
            { name: 'Warehouse', id: 3 },
        ];
        const filterDataArr = userTypeFilterListArr && userTypeFilterListArr.length
            ? [...userTypeFilterListArr]
            : [...defaultData];
        const list = filterDataArr.map((ele) => {
            if (ele) {
                return (
                    <option key={ele.name} value={ele.name}>
                        {ele.name}
                    </option>
                );
            }
            return null;
        });
        return _.compact(list);
    };

    // NOTE: startDate and endDate are intentionally NOT in formFieldList.
    // They are rendered as native <input type="date"> elements directly in
    // CreateOptionsForm and injected back into CustomDynamicFormSS via
    // setParticularFieldValue so they are available in getSummitedFormData.
    const formFieldList = [
        {
            name: "downloadType",
            type: "radio",
            size: "col-sm-12 mt-2 radioButtonText",
            position: 0,
            title: 'Select File Type:',
            formValidation: { required: true },
            radiconfig: [
                { label: "Pdf", value: "pdf" },
                { label: "Excel", value: "excel" },
            ],
        },
        ...(showApptStatus ? [{
            name: "apptStatus",
            type: "select",
            size: "col-sm-12",
            position: 0,
            title: AppConstant.commonStrings.appointmentStatus,
            formValidation: { required: true },
            getSelectData: getApptStatusList,
        }] : []),
        ...(showUserTypeFilter ? [{
            name: "userTypeFilter",
            type: "select",
            size: "col-sm-12",
            position: 0,
            title: userTypeFilterTitle,
            formValidation: { required: true },
            getSelectData: getUserTypeFilterList,
        }] : []),
        // startDate and endDate are rendered separately as native inputs
        ...(showEmail ? [{
            name: "email",
            type: "email",
            size: "col-sm-12",
            position: 0,
            title: 'Email',
            formValidation: { required: showEmail, validateEmail: showEmail },
        }] : []),
        {
            name: "columnType",
            type: "radio",
            size: "col-sm-12 mt-2 radioButtonText",
            position: 0,
            title: 'Select Columns:',
            formValidation: { required: true },
            radiconfig: [
                { label: "All", value: AppConstant.commonStrings.allStr },
                { label: "Specific Columns", value: "custom" },
            ],
        },
    ];

    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({ columnType: AppConstant.commonStrings.allStr });
    const [resetFormData, setResetFormData] = useState(0);
    const [columnHidden, setColumnHidden] = useState(true);
    const [formColumnList, setFormColumnList] = useState(formFieldList);

    useEffect(() => {
        genrateFormColumns(false);
        setEditData({ columnType: AppConstant.commonStrings.allStr, email: props?.emailValue });
    }, []);

    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
        className: isSchedulePro ? "" : 'download-seconday-btn',
    };

    const resetDateState = () => {
        setDateInputs(initialDateState);
        setDateErrors(initialDateErrors);
        setDateDirty(initialDateDirty);
        setParticularFieldValue({});
        setDateResetKey((k) => k + 1);
    };

    const handleReset = () => {
        setEditData({ columnType: AppConstant.commonStrings.allStr, email: props?.emailValue || '' });
        setColumnHidden(true);
        genrateFormColumns(false);
        resetDateState();
        if (showWarehouseFilter && setCurrentWarehouseFilterSelected) {
            setCurrentWarehouseFilterSelected({ ID: null, name: 'All Warehouse' });
        }
        if (showPoFilter) {
            setInternalFilterSelected(filterSelected || []);
            setInternalNoShow(noShow || false);
        }
    };

    // -------------------------------------------------------------------------
    // handleOpenPopup — pre-populates form state from current page filters,
    // then opens the download modal.
    // -------------------------------------------------------------------------
    const handleOpenPopup = () => {
        // Notify parent first so it can sync downloadWarehouseFilterSelected
        if (onOpenPopup) onOpenPopup();

        // Build the combined particularFieldValue object so CustomDynamicFormSS
        // receives all pre-filled values through the reactive merge path.
        const newParticularValues = {};

        // Pre-fill date inputs from the currently active date range
        if (showDateRange && defaultStartDate && defaultEndDate) {
            const startStr = moment(defaultStartDate).format('YYYY-MM-DD');
            const endStr = moment(defaultEndDate).format('YYYY-MM-DD');
            setDateInputs({ startDate: startStr, endDate: endStr });
            setDateErrors(initialDateErrors);
            setDateDirty({ startDate: false, endDate: false });
            newParticularValues.startDate = startStr;
            newParticularValues.endDate = endStr;
        } else {
            resetDateState();
        }

        // Pre-fill apptStatus / userTypeFilter in both editData AND particularFieldValue
        const newEditData = {
            columnType: AppConstant.commonStrings.allStr,
            email: props?.emailValue || '',
        };
        // Also push email into particularFieldValue so the reactive merge path
        // in CustomDynamicFormSS re-populates the already-mounted form field.
        if (showEmail && props?.emailValue) {
            newParticularValues.email = props?.emailValue;
        }
        if (showApptStatus && defaultApptStatus) {
            newEditData.apptStatus = defaultApptStatus;
            newParticularValues.apptStatus = defaultApptStatus;
        }
        if (showUserTypeFilter && defaultUserTypeFilter) {
            newEditData.userTypeFilter = defaultUserTypeFilter;
            newParticularValues.userTypeFilter = defaultUserTypeFilter;
        }

        setParticularFieldValue(newParticularValues);
        setEditData(newEditData);

        setShowModal(true);
    };

    const submitbtnData = {
        show: true,
        text: AppConstant.downloadSection.downloadTitleStr,
        className: isSchedulePro ? "" : 'btn btn-approve',
    };

    // Generate Columns checkbox form
    const genrateFormColumns = (displayStatus) => {
        let col = [...formFieldList];
        columnList.length && columnList.forEach((el) => {
            let obj = {
                name: el.value,
                type: "checkbox",
                size: "col-sm-4 column-select-checkbox",
                position: 1,
                placeholder: '',
                title: el.name,
                formValidation: { required: false },
                hideElement: { name: el.value, isHidden: displayStatus },
            };
            col.push(obj);
        });
        setFormColumnList(col);
    };

    const validateDatePair = (startStr, endStr) => {
        if (!startStr || !endStr) return '';
        if (endStr < startStr) {
            return 'Start date must be earlier than End date.';
        }
        return '';
    };

    // -------------------------------------------------------------------------
    // handleDateChange — called on every onChange of the native date inputs.
    // Mirrors the pattern in BreaksFormSS.handleChange.
    // -------------------------------------------------------------------------
    const handleDateChange = (fieldName, value, validity) => {
        const badInput = validity ? validity.badInput : false;
        const fieldLabel = fieldName === 'startDate' ? 'Start Date' : 'End Date';

        const err = validateDateInput(value, badInput, fieldLabel);

        const newDateInputs = { ...dateInputs, [fieldName]: value };

        if (err) {
            setDateErrors((prev) => ({ ...prev, [fieldName]: err, dateRange: '' }));
            setDateDirty((prev) => ({ ...prev, [fieldName]: true }));
            setDateInputs(newDateInputs);
            // Push value into CustomDynamicFormSS so it remains in submitted data
            setParticularFieldValue((prev) => ({ ...prev, [fieldName]: value }));
            return;
        }

        // Clear individual field error
        const newErrors = { ...dateErrors, [fieldName]: '' };

        // Fix 1: real-time cross-field check
        const start = fieldName === 'startDate' ? value : dateInputs.startDate;
        const end = fieldName === 'endDate' ? value : dateInputs.endDate;
        newErrors.dateRange = validateDatePair(start, end);

        setDateErrors(newErrors);
        setDateInputs(newDateInputs);
        setParticularFieldValue((prev) => ({ ...prev, [fieldName]: value }));
    };

    // -------------------------------------------------------------------------
    // handleDateBlur — called on onBlur of the native date inputs.
    // -------------------------------------------------------------------------
    const handleDateBlur = (fieldName, validity) => {
        setDateDirty((prev) => ({ ...prev, [fieldName]: true }));
        const badInput = validity ? validity.badInput : false;
        const fieldLabel = fieldName === 'startDate' ? 'Start Date' : 'End Date';
        const currentVal = dateInputs[fieldName] || '';
        const err = validateDateInput(currentVal, badInput, fieldLabel);
        if (err) {
            setDateErrors((prev) => ({ ...prev, [fieldName]: err }));
            return;
        }
        // Cross-field on blur
        const start = fieldName === 'startDate' ? currentVal : dateInputs.startDate;
        const end = fieldName === 'endDate' ? currentVal : dateInputs.endDate;
        setDateErrors((prev) => ({ ...prev, [fieldName]: '', dateRange: validateDatePair(start, end) }));
    };

    // -------------------------------------------------------------------------
    // getSummitedFormData — called by CustomDynamicFormSS on submit.
    // -------------------------------------------------------------------------
    const getSummitedFormData = (data) => {
        // Validate date fields before proceeding
        if (showDateRange) {
            // Mark both as dirty so errors show even if untouched
            setDateDirty({ startDate: true, endDate: true });

            const startErr = validateDateInput(dateInputs.startDate, false, 'Start Date');
            const endErr = validateDateInput(dateInputs.endDate, false, 'End Date');

            let startDateRequired = '';
            let endDateRequired = '';
            if (!dateInputs.startDate && !startErr) startDateRequired = 'Start Date is required.';
            if (!dateInputs.endDate && !endErr) endDateRequired = 'End Date is required.';

            const rangeErr = validateDatePair(dateInputs.startDate, dateInputs.endDate);

            const finalErrors = {
                startDate: startErr || startDateRequired,
                endDate: endErr || endDateRequired,
                dateRange: (!startErr && !startDateRequired && !endErr && !endDateRequired) ? rangeErr : '',
            };
            setDateErrors(finalErrors);

            if (finalErrors.startDate || finalErrors.endDate || finalErrors.dateRange) {
                return; // Abort — errors shown inside popup
            }
        }

        let payload = downloadData();
        let df = [];

        if (showDateRange) {
            const start = moment.utc(dateInputs.startDate);
            const end = moment.utc(dateInputs.endDate);
            start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            end.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });

            // Compute the inclusive last allowed date as a YYYY-MM-DD string.
            // For monthLimit: startDate + N months - 1 day  (e.g. Mar 1 + 3m - 1d = May 31)
            // For weeks:      startDate + N weeks - 1 day
            // Comparing YYYY-MM-DD strings avoids timezone-shift false positives that
            // occurred when mixing moment.utc() datetimes with local moment() datetimes.
            let inclusiveMaxDateStr;
            if (weeks) {
                inclusiveMaxDateStr = moment(dateInputs.startDate)
                    .add(weeks, 'weeks')
                    .subtract(1, 'day')
                    .format('YYYY-MM-DD');
            } else {
                inclusiveMaxDateStr = moment(dateInputs.startDate)
                    .add(monthLimit, 'months')
                    .subtract(1, 'day')
                    .format('YYYY-MM-DD');
            }

            // dateInputs.endDate is already a YYYY-MM-DD string — direct comparison is safe.
            if (dateInputs.endDate > inclusiveMaxDateStr) {
                weeks
                    ? showAlert(toast.TYPE.ERROR, `The date range must be within ${weeks} weeks.`)
                    : showAlert(toast.TYPE.ERROR, `The date range must be within ${monthLimit} months.`);
                return;
            }

            payload.options.startDate = start.toISOString();
            payload.options.endDate = end.toISOString();
        }

        if (showEmail) {
            payload.userDetails.email = data.email;
        }
        if (showApptStatus) {
            payload.options.apptStatus = data.apptStatus;
        }
        if (showUserTypeFilter) {
            payload.options.UserTypeFilter = data.userTypeFilter === 'All User' ? null : data.userTypeFilter;
        }
        if (showPoFilter) {
            payload.options.filterSelected = internalFilterSelected && internalFilterSelected.length ? formMultiSelectDataForPayload(internalFilterSelected) : 'Not Scheduled,';
            payload.options.noShow = internalNoShow;
        }

        if (data.columnType === AppConstant.commonStrings.allStr) {
            if (columnList.length > 15 && payload.downloadType === 'pdf') {
                df = columnList.slice(0, 15);
            } else {
                df = columnList;
            }
        } else {
            columnList.forEach((el) => {
                if (data[el.value]) {
                    df.push(el);
                }
            });
        }

        if (allowPermission && !currentWarehouseFilterSelected?.ID && userType !== "CARRIER") {
            const warehouseNameColumn = { name: "Warehouse", value: "WarehouseName" };
            if (df.find(col => col.value === 'WarehouseNameWithExternalSiteID')) {
                // skip
            }
            else if (!df.find(col => col.value === 'WarehouseName')) {
                df.unshift(warehouseNameColumn);
            }
        }

        payload.columnType = data.columnType;
        payload.downloadType = data.downloadType;
        payload.downloadFilters = df;

        if (payload.columnType === "custom" && payload.downloadFilters.length < 3) {
            showAlert(toast.TYPE.ERROR, "Select atleast three column or Select All !");
        } else {
            if (payload.downloadType === 'pdf' && payload.downloadFilters.length > 15) {
                showAlert(toast.TYPE.ERROR, "Max 15 columns allowed for PDF Format !");
            } else {
                downloadReport(payload);
                closeFilterPopup();
            }
        }
    };

    const getFormFieldData = (data, name, control, inputs) => {
        if (name === 'columnType') {
            if (data && data === AppConstant.commonStrings.allStr) {
                setColumnHidden(true);
                genrateFormColumns(false);
            } else {
                setColumnHidden(false);
                genrateFormColumns(true);
            }
        }
    };

    // -------------------------------------------------------------------------
    // Native date input block — rendered directly inside CreateOptionsForm.
    // -------------------------------------------------------------------------
    const renderDateFields = () => {
        if (!showDateRange) return null;
        return (
            <div className="row px-3 gy-2 mb-1">
                {/* Start Date */}
                <div className="col-sm-6">
                    <label className="inputTitle">
                        Start Date&nbsp;<span className="color-red">*</span>
                    </label>
                    <input
                        key={`startDate-${dateResetKey}`}
                        type="date"
                        className={`w-100 customTextInput${dateDirty.startDate && dateErrors.startDate ? ' customError' : ''}`}
                        value={dateInputs.startDate}
                        max={getStartDateMaxStr()}
                        onChange={(e) => handleDateChange('startDate', e.target.value, e.target.validity)}
                        onBlur={(e) => handleDateBlur('startDate', e.target.validity)}
                    />
                    {dateDirty.startDate && dateErrors.startDate && (
                        <span className="errorMessage d-block">{dateErrors.startDate}</span>
                    )}
                </div>

                {/* End Date */}
                <div className="col-sm-6">
                    <label className="inputTitle">
                        End Date&nbsp;<span className="color-red">*</span>
                    </label>
                    <input
                        key={`endDate-${dateResetKey}`}
                        type="date"
                        className={`w-100 customTextInput${dateDirty.endDate && dateErrors.endDate ? ' customError' : ''}`}
                        value={dateInputs.endDate}
                        min={dateInputs.startDate || undefined}
                        max={getEndDateMaxStr()}
                        onChange={(e) => handleDateChange('endDate', e.target.value, e.target.validity)}
                        onBlur={(e) => handleDateBlur('endDate', e.target.validity)}
                    />
                    {dateDirty.endDate && dateErrors.endDate && (
                        <span className="errorMessage d-block">{dateErrors.endDate}</span>
                    )}
                </div>

                {dateErrors.dateRange && (
                    <div className="col-sm-12">
                        <span className="errorMessage d-block">{dateErrors.dateRange}</span>
                    </div>
                )}

                {dateRangeDisclaimerText && (
                    <div className="col-sm-12 mt-1">
                        <p className="f-12 color-red mb-0">
                            <i className="fa-solid fa-circle-info me-1"></i>
                            {dateRangeDisclaimerText}
                        </p>
                    </div>
                )}
            </div>
        );
    };

    // Generate Filters Form
    const CreateOptionsForm = () => {
        return (
            <>
                <div className='downlaod-popup'>
                    {allowPermission && showWarehouseFilter && (
                        <div className='mb-3 px-3'>
                            <p className='f-14 fw-600'>Select Warehouse</p>
                            <WarehouseFiltersForReports
                                currentWarehouseFilterSelected={currentWarehouseFilterSelected}
                                setCurrentWarehouseFilterSelected={setCurrentWarehouseFilterSelected}
                                themeSelected={themeSelected}
                                maxChars={40}
                            />
                        </div>
                    )}

                    {/* Native date inputs rendered */}
                    {renderDateFields()}

                    {/* PO Status filter and No Show checkbox — rendered after Select File Type */}
                    {showPoFilter && (
                        <div className='mb-3 px-3'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className='flex-grow-1'>
                                    <p className='f-14 fw-600 mb-1'>Select Filters</p>
                                    <MultiSelectDropDownNew
                                        placeholder={filterOptions && filterOptions.length ? filterOptions[1]?.name : 'Not Scheduled'}
                                        options={filterOptions}
                                        id={'download-po-filter'}
                                        filterSelected={internalFilterSelected}
                                        setFilterSelected={setInternalFilterSelected}
                                        loading={false}
                                    />
                                </div>
                                <div className='d-flex gap-2 align-items-center mt-3'>
                                    <label htmlFor='downloadNoShowCheckbox' style={{ cursor: 'pointer', marginBottom: 0 }}>
                                        No Show
                                    </label>
                                    <input
                                        type='checkbox'
                                        id='downloadNoShowCheckbox'
                                        checked={internalNoShow}
                                        onChange={(e) => setInternalNoShow(e.target.checked)}
                                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <CustomDynamicFormSS
                        formFieldList={formColumnList}
                        sort={true}
                        cancelBtn={cancelbtndata}
                        submitbtn={submitbtnData}
                        themeSelected={themeSelected}
                        getSummitedFormData={getSummitedFormData}
                        getFormFieldData={getFormFieldData}
                        editFormData={editData}
                        loading={false}
                        resetFormData={resetFormData}
                        setParticularFieldValue={particularFieldValue}
                        getCancelBtnClick={handleReset}
                    />

                    {columnList.length > 15 ? <div className='f-10 color-red'>Note: PDF format support 15 columns max.</div> : ''}
                </div>
            </>
        );
    };

    // Close Filter Popup
    const closeFilterPopup = () => {
        setShowModal(false);
        setFormColumnList(formFieldList);
        resetDateState();
        if (showWarehouseFilter && setCurrentWarehouseFilterSelected) {
            setCurrentWarehouseFilterSelected({ ID: null, name: "All Warehouse" });
        }
        if (showPoFilter) {
            setInternalFilterSelected(filterSelected || []);
            setInternalNoShow(noShow || false);
        }
    };

    // Download Options Popup
    const showPopup = () => {
        const popupObj = {
            id: 'downloadreport1',
            modalLabel: 'downloadreport1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.downloadSection.downloadTitleStr,
            bodyText: CreateOptionsForm(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: { show: true, text: AppConstant.commonStrings.yes },
                btn2: { show: true, text: AppConstant.commonStrings.no },
            },
        };

        return isSchedulePro
            ? <SSPopup {...popupObj} popupBtnHandler={(text) => { }} closepopup={() => closeFilterPopup()} themeSelected={themeSelected} showModal={showModal} />
            : <Popup   {...popupObj} popupBtnHandler={(text) => { }} closepopup={() => closeFilterPopup()} themeSelected={themeSelected} showModal={showModal} />;
    };

    return isSchedulePro ? (
        <>
            <button
                className={`${isDisabled ? 'disabled' : 'pointer'} download-section-ss p-1 px-2 pointer`}
                aria-expanded="false"
                disabled={isDisabled}
                onClick={handleOpenPopup}
            >
                <button className={`${isDisabled ? 'disabled' : 'pointer'} d-flex justify-content-start align-items-center me-2 downloadSection no-bg no-border`}>
                    {isLoading && (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    )}
                    <span className='font-default'> <i className="fa-solid fa-download"></i> </span>
                    <div className={`downloadButton-ss ms-1 bg-light ${themeSelected}`}>
                        {AppConstant.downloadSection.downloadTitleStr}
                    </div>
                </button>
            </button>
            {showPopup()}
        </>
    ) : (
        <>
            <button
                className={`${isDisabled ? 'disabled' : 'pointer'} dropdown border border-dark rounded-2 p-1 px-2 d-flex justify-content-start align-items-center`}
                aria-expanded="false"
                disabled={isDisabled}
                onClick={handleOpenPopup}
            >
                <button className={`${isDisabled ? 'disabled' : 'pointer'} d-flex justify-content-start align-items-center me-2 downloadSection  no-bg no-border`}>
                    {isLoading && (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    )}
                    {themeSelected === 'light-mode' ? <DownloadIconLight className='me-2' /> : <DownloadIconDark className='me-2' />}
                    <div className={`downloadButton ${themeSelected}`}>{AppConstant.downloadSection.downloadTitleStr}</div>
                </button>
            </button>
            {showPopup()}
        </>
    );
};

export default memo(DownloadSectionBECustomFeilds);
